import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";

export const healthcheckApi = createApi({
  reducerPath: "healthcheck",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getHealth: builder.query<boolean, void>({
      query: () => ({
        url: "HealthCheck",
      }),
    }),
  }),
});

export const { useGetHealthQuery } = healthcheckApi;
